import React, { useEffect, useState } from "react";

const AllowanceBox = ({ jobAllowancedata, jobDataMain }) => {
  const [totalAllowance, setTotalAllowance] = useState(0);

  const calculateTotalAllowance = () => {
    let total = 0;

    // Check if jobAllowancedata is an array before using forEach
    if (Array.isArray(jobAllowancedata)) {
      jobAllowancedata.forEach((jobdata) => {
        total += jobdata.TotalAllowance;
      });
    }

    // Add the totalExtraAmount to the total
    total += jobDataMain[0]?.TotalIncentiveAmount;

    // Set the total in the state
    setTotalAllowance(total);
  };

  useEffect(() => {
    calculateTotalAllowance();
  }, [jobAllowancedata, jobDataMain]);

  // Format the totalAllowance for display
  const formattedTotalAllowance = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(totalAllowance);

  return (
    <div className="allowance-box ">
      {jobAllowancedata !== "" && jobAllowancedata !== null
        ? jobAllowancedata?.map((jobdata, index) => (
            <>
              <p className="allowance-show">
                {jobdata?.AllowanceType === "TLA"
                  ? "TL Allowance"
                  : jobdata?.AllowanceType === "SPA"
                  ? "Supervisor Allowance"
                  : jobdata?.AllowanceType === "UGA"
                  ? "UG Allowance"
                  : jobdata?.AllowanceType === "SWA"
                  ? "SW Allowance"
                  : jobdata?.AllowanceType}
                : &#x20B9;{jobdata?.TotalAllowance}
              </p>
            </>
          ))
        : ""}
      <div className="allowant-total-box">
        <p className="allowance-show">
          Incentive : &#x20B9;{jobDataMain[0]?.TotalIncentiveAmount}
        </p>
        <p className="allowance-price">Total : {formattedTotalAllowance}</p>
      </div>
    </div>
  );
};

export default AllowanceBox;
